import React from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { firstNameOf } from '../lib/format';

export const Connected = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  if (!state?.inviterName) return <Navigate to="/" replace />;
  const first = firstNameOf(state.inviterName);

  return (
    <div className="page" data-testid="connected-page">
      <div className="connected-content">
        <CheckCircle className="connected-icon" />
        <h1 className="connected-title">You&apos;re connected with {first}</h1>
        <p className="connected-sub">
          You can now see recommendations from {first} and other people you connect with.
        </p>
        <button className="welcome-btn" onClick={() => navigate('/', { replace: true })} data-testid="connected-see-recs">
          See recommendations
        </button>
        <button className="connected-secondary" onClick={() => navigate('/add')} data-testid="connected-first-rec">
          Make your first recommendation
        </button>
      </div>
    </div>
  );
};
